import React, { Component } from 'react';
import { Form, Container, Row, Col, Button, Spinner } from 'react-bootstrap';
import { GoogleLogin } from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import GoogleLogo from '../../img/Google_Logo.png';
import apiUrl from '../../utils/apiUrl';
import AppSpinner from '../AppSpinner/AppSpinner';
import { setInStorage } from '../../utils/storage';
import { userLogin, setToken, setUser, setUserId } from '../../redux/modules/auth';
import { connect } from 'react-redux';
import googleClientId from '../../utils/appIds';
import './styles/styles.scss';

function mapDispatchToProps(dispatch) {
  return {
    userLogin: () => dispatch(userLogin()),
    setUser: user => dispatch(setUser(user)),
    setUserId: userId => dispatch(setUserId(userId)),
    setToken: token => dispatch(setToken(token))
  };
}

class ConnectedLoginComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      formValidated: false,
      submitting: false,
      loading: false,
      error: ''
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSignIn = this.handleSignIn.bind(this);
    this.responseGoogleSuccess = this.responseGoogleSuccess.bind(this);
    this.responseGoogleFailure = this.responseGoogleFailure.bind(this);
    this.updateUserSession = this.updateUserSession.bind(this);
    this.responseFacebook = this.responseFacebook.bind(this);
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  async handleSignIn() {

    const { email, password } = this.state;

    const userWithGoogleFetch = fetch(`${apiUrl}/signin/google_facebook/get`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        withGoogle: true
      })
    });

    const userWithFbFetch = fetch(`${apiUrl}/signin/google_facebook/get`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        withFB: true
      })
    });

    const userWithGoogleProm = await userWithGoogleFetch;
    const userWithFbProm = await userWithFbFetch;

    const userWithGoogle = await userWithGoogleProm.json();
    const userWithFb = await userWithFbProm.json();

    if (userWithGoogle.success && userWithGoogle.userFound) {
      return { success: false, error: 'Parece que estás intentando iniciar sesión con una cuenta de Google. Da click en "Continúa con Google" para ingresar.' };
    } else if (userWithFb.success && userWithFb.userFound) {
      return { success: false, error: 'Parece que estás intentando iniciar sesión con una cuenta de Facebook. Da click en "Continúa con Facebook" para ingresar.' };
    }

    const signinResponse = await fetch(`${apiUrl}/signin/account/signin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        adminLogin: true,
        password
      })
    });

    const signin = await signinResponse.json();

    if (!signin.success) return { success: false, error: 'Datos incorrectos.' };

    return { success: true, user: signin };
  }

  async handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ formValidated: true, submitting: true });
    const form = event.currentTarget;

    if (form.checkValidity()) {
      const resp = await this.handleSignIn();

      if (!resp.success) this.setState({ error: resp.error, submitting: false });
      else await this.updateUserSession(resp.user.userId, resp.user.token);
    }

  }

  async responseGoogleSuccess(response) {

    const tokenId = response.tokenId;
    const promLogin = await fetch(`${apiUrl}/signin/google/signin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token: tokenId,
        adminLogin: true
      })
    });

    const jsonLogin = await promLogin.json();

    if (jsonLogin.success) await this.updateUserSession(jsonLogin.userId, jsonLogin.token);
    else this.setState({ error: jsonLogin.message, loading: false });
  }

  responseGoogleFailure() {
    this.setState({ loading: false });
  }

  async responseFacebook(response) {

    this.setState({ loading: true });

    if (response && response.email) {

      const { email, accessToken, userID } = response;

      const promLogin = await fetch(`${apiUrl}/signin/facebook/signin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          accessToken,
          userID,
          adminLogin: true
        })
      });

      const jsonLogin = await promLogin.json();

      if (jsonLogin.success) await this.updateUserSession(jsonLogin.userId, jsonLogin.token);
      else this.setState({ error: jsonLogin.message, loading: false });

    } else {
      this.setState({ loading: false });
    }

  }

  async updateUserSession(userId, token) {

    setInStorage('nibi_admin_app', { token });

    this.props.setToken({ token });
    this.props.setUserId({ userId });

    const dataUser = await fetch(`${apiUrl}/users/user/${userId}`);
    const res = await dataUser.json();

    this.props.setUser({ user: res });
    this.props.userLogin();

  }

  render() {

    const {
      email,
      password,
      formValidated,
      submitting,
      error,
      loading
    } = this.state;

    return (
      <div className="login-component">
        <Container>
          <Row className="justify-content-center">
            <Col md={5} xs={12}>
              <div className="login-form">
                {
                  loading ? <AppSpinner /> :
                    <>
                      <Form noValidate validated={formValidated} onSubmit={this.handleSubmit}>
                        <Form.Group>
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            value={email}
                            name="email"
                            onChange={this.handleInputChange}
                            required
                            placeholder="Email"
                          />
                          <Form.Control.Feedback type="invalid">
                            Ingresa un email válido.
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group>
                          <Form.Label>Contraseña</Form.Label>
                          <Form.Control
                            type="password"
                            value={password}
                            name="password"
                            onChange={this.handleInputChange}
                            required
                            placeholder="Contraseña"
                          />
                          <Form.Control.Feedback type="invalid">
                            Ingresa una contraseña válida.
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Button type="submit" className="nibi-btn">
                          {
                            submitting ? <Spinner animation="border" variant="warning" size="sm" /> : 'Ingresar'
                          }
                        </Button>

                      </Form>

                      <div className="signup-separador">
                        <span className="line"></span>
                        <span className="text">o</span>
                        <span className="line"></span>
                      </div>
                      <Row className="google-fb-signup">
                        <Col xs={12}>
                          <GoogleLogin
                            clientId={googleClientId}
                            buttonText="Continúa con Google"
                            onSuccess={this.responseGoogleSuccess}
                            onFailure={this.responseGoogleFailure}
                            render={renderProps => (
                              <button
                                className="google-login-btn"
                                onClick={() => {
                                  this.setState({ loading: true });
                                  renderProps.onClick();
                                }}
                                disabled={renderProps.disabled}
                              >
                                <div className="logo">
                                  <img src={GoogleLogo} alt="" style={{ height: 23, width: 23 }} />
                                </div>
                                <span className="text">Continúa con Google</span>
                              </button>
                            )}
                          />
                        </Col>
                        <Col xs={12}>
                          <FacebookLogin
                            appId="207412983912631"
                            fields="name,email"
                            callback={this.responseFacebook}
                            cssClass="fb-login-btn"
                            icon="fa-facebook"
                            textButton="Continúa con Facebook"
                            isMobile={false}
                          />
                        </Col>
                      </Row>
                      {
                        error && <div className="signup-error">{error}</div>
                      }
                    </>
                }
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const LoginComponent = connect(null, mapDispatchToProps)(ConnectedLoginComponent);

export default LoginComponent;
